import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    costs: [],
    loading: false,
    saving: false,
    formData: {}
};

export default function cost(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_COST:
            newState.loading = true;
            break;

        case actions.SAVING_COST:
            newState.saving = true;
            break;

        case actions.RECEIVED_COSTS:
            newState.loading = false;
            newState.costs = utils.mapById(action.payload)
            break;

        case actions.SAVED_COST:
            let found = false;

            for (let i = 0; i < newState.costs.length; i++) {
                if(newState.costs[i].id === action.payload.id){
                    found = true;

                    newState.costs[i] = action.payload;
                }
            }

            if(!found) {
                newState.costs.add(
                    action.payload
                );
            }

            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_CLIENT_RATES:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.UPDATED_FILE:
            for (let i = 0; i < newState.costs.length; i++) {
                if(newState.costs[i].id === action.payload.id){
                    newState.costs[i] = {...newState.costs[i], url: action.payload.url};
                }
            }
            break;

        case actions.UPDATEFORMDATA_COST:
            newState.formData = action.payload.formData;
            break;

        case actions.CLEARFORMDATA_COST:
            newState.formData = {};
            break;

        case actions.REMOVED_COST:
            newState.loading = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/cost.js